import $ from 'jquery'

( () => {
  const infoTextElem = $('.internal .infotext')

  $('#expand').click(function(e) {
    e.preventDefault();
    $('.gallerylinks > a.active').click();
  });

  if( infoTextElem.length ) {
    infoTextElem.each((idx, item) => {
      const $item = $(item)

      if( $item.height() >= 29 ) {
        $item.css('height', '28px');
        $item.prev('.infotitle').addClass('over');
      }
    
      $item.prev('.infotitle').on('click', () => {
        const that = event.target
        
        $(that).toggleClass('open');
        $(that).next('.infotext').toggleClass('open');
      });
    })
    
  }
})()